import React from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import './index.scss';

function getPropsFromOption(options: {
  maskClassName: any;
  style: any;
  className: any;
  onMaskClick: any;
  maskClosable?: true;
  hasMask?: false;
}) {
  const { hasMask = false, maskClassName, maskClosable = true, style, className, onMaskClick } = options;
  return {
    style,
    className,
    maskClosable,
    hasMask,
    maskClassName,
    onMaskClick,
  };
}

type ToastOption = {
  hasMask?: boolean;
  maskClassName?: string;
  maskClosable?: boolean;
  style?: object;
  className?: string;
  onMaskClick?: Function;
  duration?: number;
};
export default class Toast extends React.Component<any, any> {
  static defaultProps = {
    show: true,
  };

  // 移除tips的定时器
  static timer: any;

  // 当前展示tips的内容
  static content: any;

  // 待展示的tips队列

  static create(content: any, options: ToastOption = {}) {
    const dom = document.createElement('div');
    document.body.appendChild(dom);
    dom.style.position = 'fixed';
    dom.style.zIndex = '9999';
    const refData = {
      content,
      options,
      dom,
    };

    this.show(refData);
    return refData;
  }

  static show(refData: { content: any; options: any; dom: any }) {
    const { content, options, dom } = refData;
    const { duration = 1500 } = options;
    const elem = React.createElement(
      this,
      {
        show: true,
        ...getPropsFromOption(options),
        refData,
      },
      [content],
    );

    ReactDOM.render(elem, dom);

    if (duration > 0) {
      setTimeout(() => {
        this.destroy(refData);
      }, duration);
    }

    return this;
  }

  static destroy(refData: { dom: any; content?: any; options?: any }) {
    if (!refData?.dom) {
      return;
    }
    const { options, dom } = refData;
    // 渲染退出动画
    const elem = React.createElement(
      this,
      {
        show: false,
        onAnimationEnd: () => {
          // 待动画结束后移除dom节点
          ReactDOM.unmountComponentAtNode(dom);
          document.body.removeChild(dom);
        },
        ...getPropsFromOption(options),
      },
      [refData.content],
    );
    ReactDOM.render(elem, dom);
  }

  static kill(refData: { dom: any; options?: any }) {
    if (!refData?.dom) {
      return;
    }
    const { dom } = refData;
    ReactDOM.unmountComponentAtNode(dom);
    document.body.removeChild(dom);
  }

  onMaskClick = () => {
    const { maskClosable, onMaskClick } = this.props;
    onMaskClick?.();
    if (maskClosable) {
      Toast.destroy(this.props.refData);
    }
  };

  render() {
    const { children, show, onAnimationEnd, hasMask, maskClassName } = this.props;
    let className = classnames({
      toast: true,
      'toast-enter-animation': show,
      'toast-leave-animation': !show,
    });
    if (this.props.className) {
      className = `${className} ${this.props.className}`;
    }
    const content = (
      <div className={className} style={this.props.style} onAnimationEnd={onAnimationEnd}>
        {children}
      </div>
    );
    return hasMask && show ? (
      <div className={`toast-mask-bg ${maskClassName || ''}`} onClick={this.onMaskClick}>
        {content}
      </div>
    ) : (
      content
    );
  }
}
